import React, { useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { Helmet } from 'react-helmet-async';
import { CreativeServicesComponent } from './homeComponents';
import HomepageReveal from './homeComponents/HomepageReveal';
import MediaGallery from './homeComponents/MediaGallery';
import { HomeLandingPage } from './homeStyle';
import { openProjectModalWithInfo } from '../../actions/landing_page_actions';
import { HomepageSectionsStyle, ServiceCards, TrustSection, ProcessSection, HomepageReviews, FinalBooking, HomepageBlogPosts } from './homeComponents/HomepageSections';

const Homepage = (props) => {
  const dispatch = useDispatch();
  useEffect(() => {
    if (props.match.params.referral_code) props.setModal(true);
  }, []);
  const onBook = () => {
    if (props.currentUser) props.history.push('/create-project');
    else dispatch(openProjectModalWithInfo(null));
  };
  if (props.currentUser && !props.modalOpen && !props.projectModalOpen && !props.VSModalOpen) {
    props.history.push('/dashboard');
    return null;
  }
  return <HomeLandingPage className="landingPage">
    <Helmet>
      <title>Real Estate Media, Delivered in 24 Hours | Modern Angles</title>
      <link rel="canonical" href={window.location.origin + '/'} />
      <meta name="description" content="Professional real estate photography, video, drone, floor plans, 3D tours, and virtual staging. One simple booking. All media delivered within 24 hours." />
    </Helmet>
    <CreativeServicesComponent />
    <HomepageSectionsStyle>
      <HomepageReveal><ServiceCards /></HomepageReveal>
      <HomepageReveal><TrustSection /></HomepageReveal>
      <HomepageReveal><ProcessSection onBook={onBook} /></HomepageReveal>
      <HomepageReveal><MediaGallery /></HomepageReveal>
      <HomepageReveal><HomepageReviews /></HomepageReveal>
      <HomepageReveal><FinalBooking onBook={onBook} /></HomepageReveal>
      <HomepageReveal><HomepageBlogPosts /></HomepageReveal>
    </HomepageSectionsStyle>
  </HomeLandingPage>;
};
export default withRouter(Homepage);